import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LandRoleService } from '../service/land-role.service';
import * as LandRoleActions from './land-role.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class LandRoleEffects {
  private actions$ = inject(Actions);
  private landRoleService = inject(LandRoleService);

  getLandRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LandRoleActions.loadLandRole),
      switchMap((action) => {
        return this.landRoleService.getLandRole(action.language).pipe(
          map((_response) => LandRoleActions.loadLandRoleSuccess({ landRole: _response.client })),
          catchError((error) => of(LandRoleActions.loadLandRoleFailure({ error })))
        );
      })
    )
  );
}
